import { cn } from '@ngg/storefront-utils';
import { HTMLAttributes } from 'react';

type ProductListHeaderProps = HTMLAttributes<HTMLElement>;

const ProductListHeader = ({
  className,
  children,
  ...props
}: ProductListHeaderProps) => {
  return (
    <header
      className={cn(
        'flex justify-between gap-4 py-4 text-base tracking-wide',
        className,
      )}
      {...props}>
      {children}
    </header>
  );
};

ProductListHeader.displayName = 'ProductListHeader';

export default ProductListHeader;
